// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalInfo_container__Hla4_","description":"PersonalInfo_description__vaLXT","note":"PersonalInfo_note__17ciC"};